import { UserTaskRole } from 'common/types';

export enum ProjectEnvType {
  INNER = 'INNER',
  OUTER = 'OUTER',
}

export const BiddingRoleMap = {
  [UserTaskRole.ExternalContacts]: '制作方',
  [UserTaskRole.Allocator]: '需求方',
};

export const TaskRoleMap = {
  [UserTaskRole.Allocator]: '需求方',
  [UserTaskRole.ExternalContacts]: '制作方',
  [UserTaskRole.InternalContacts]: '审核方',
};

export enum InternalContactsBiddingStatus {
  UnConfirmed = 'UNDETERMINED',
  Confirmed = 'CONFIRMED',
  Revoked = 'REVOCATION',
  PreSelected = 'PRE_SELECTED', // 已预选
}

export const InternalContactsBiddingStatusMap = {
  [InternalContactsBiddingStatus.UnConfirmed]: '待确认',
  [InternalContactsBiddingStatus.Confirmed]: '已确认',
  [InternalContactsBiddingStatus.Revoked]: '已撤销',
  [InternalContactsBiddingStatus.PreSelected]: '已预选',
};

export const BiddingStatusMap = {
  [InternalContactsBiddingStatus.UnConfirmed]: '竞标中',
  [InternalContactsBiddingStatus.Confirmed]: '已成功',
  [InternalContactsBiddingStatus.Revoked]: '已撤回',
  [InternalContactsBiddingStatus.PreSelected]: '已预选',
};

export enum ExternalContactsBiddingStatus {
  Inviting = 'INVITING', // 邀请中
  UnConfirmed = 'UNDETERMINED', // 待确认
  Confirmed = 'CONFIRMED', // 已确认
  Rejected = 'LOSE_ELECTION', // 落选
  Revoked = 'REVOCATION', // 已撤销
  Recommended = 'RECOMMENDED', //推荐中
  PreSelected = 'PRE_SELECTED', // 已预选
}

export const ExternalContactsBiddingStatusMap = {
  [ExternalContactsBiddingStatus.UnConfirmed]: '待确认',
  [ExternalContactsBiddingStatus.Confirmed]: '已确认',
  [ExternalContactsBiddingStatus.Rejected]: '已落选',
  [ExternalContactsBiddingStatus.Revoked]: '已取消',
};
